export enum CounselingTypeEnum {
    Individual = 1,
    Family = 2,
    Group = 3,
}
